import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `Ruta/deleteRutaSeleccion`, method: 'POST', body: {list}, token: token})
}